import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

// slices
import { loginState } from '../login/login.slice'

// constants
import {
    CHECK_MARKET_DOMAIN,
    DOMAIN_LIST,
    SUPER_ADMIN,
} from '../../constants/roles'

// routes
import { PRIVATE_ROUTES } from '../../routes'
import { workspaceState } from '../workSpace/workSpace.slice'

// PUBLIC ROUTES
const PublicRoute = () => {
    const { userProfile, status } = useSelector(loginState)
    const { isByPass } = useSelector(workspaceState)
    if (
        status !== 'loading' &&
        userProfile !== undefined &&
        userProfile?.role?.roleName !== undefined &&
        userProfile?.phone
    ) {
        const hasMarketDomain =
            userProfile?.appPermission?.length > 0
                ? userProfile?.appPermission.some((app) =>
                    CHECK_MARKET_DOMAIN.includes(app.domain)
                )
                : false
        if (
            DOMAIN_LIST.includes(userProfile?.currentWorkSpace?.domain) &&
            (userProfile?.role?.roleName === SUPER_ADMIN ||
                (userProfile?.role?.roleName !== SUPER_ADMIN &&
                    hasMarketDomain))
        ) {
            // return <Navigate to={`${PRIVATE_ROUTES.workSpace}`} />
            // return <Navigate to={`${PRIVATE_ROUTES.home}`} />
            return <Navigate to={`${PRIVATE_ROUTES.inspirationGallery.root}`} />
        } else if (
            userProfile?.activeProject === null &&
            DOMAIN_LIST.includes(userProfile?.currentWorkSpace?.domain)
        ) {
            // return <Navigate to={`${PRIVATE_ROUTES.userWorkSpace}`} />
            return <Navigate to={`${PRIVATE_ROUTES.home}`} />
        } else if (
            userProfile?.activeProject === null &&
            !DOMAIN_LIST.includes(userProfile?.currentWorkSpace?.domain)
        ) {
            return <Navigate to={`${PRIVATE_ROUTES.projects.root}`} />
        } else {
            
                return <Navigate to={`${PRIVATE_ROUTES.overview}`} />
           
        }
    } else {
        return <Outlet />
    }
}

export default PublicRoute
